import { combineReducers } from 'redux';
import eventReducer from './eventReducer';
import layoutReducer from './layoutReducer';
import screensReducer from './screens';
import authReducer from './authReducer';
import userReducer from './userReducer';
import pvsReducer from './pvsReducer';
import awardsReducer from './awardsReducer';

const rootReducer = combineReducers({
  Layout: layoutReducer,
  event: eventReducer,
  screens: screensReducer,
  auth: authReducer,
  user: userReducer,
  pvs: pvsReducer,
  awards: awardsReducer,
  // Add other reducers here
});

export default rootReducer;
